import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=266664ce&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopEntityAgencyProfile: require('/srv/rir-platform/tourism/src/tourism-front/components/common/TopEntityAgencyProfile/index.vue').default,EntityContent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EntityContent/index.vue').default,Section: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Section/index.vue').default,ExcursionCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ExcursionCard/index.vue').default,RouteCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RouteCard/index.vue').default,JournalCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/JournalCard/index.vue').default,SectionAgencyBranches: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionAgencyBranches/index.vue').default,SectionComments: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionComments/index.vue').default,SectionBannerAppMobile: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionBannerAppMobile/index.vue').default,SectionBillboard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionBillboard/index.vue').default,ErrorComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ErrorComponent/index.vue').default})
